<template>
  <div>
    <el-tabs type="border-card" class="fullHeight">
      <el-tab-pane
        class="paddingBody content"
        :label="$t('Tareas')"
        v-loading="loadingAllDataRequired"
        element-loading-text="Cargando..."
        element-loading-background="rgba(255, 255, 255)"
      >
        <el-row>
          <el-col :md="24">
            <el-button
              v-if="canSendToApproval()"
              type="warning"
              v-loading.fullscreen.lock="isLoading"
              class="right"
              @click="sendToReview()"
            >
              <b>{{$t('Enviar a Revisión')}}</b>
            </el-button>

            <el-button
              style="margin-right: 20px;"
              @click="handleAddTask()"
              type="primary"
              icon="el-icon-plus"
              class="right"
            >
              <b>Agregar paso del proceso</b>
            </el-button>
          </el-col>

          <el-col :md="24">
            <el-table
              class="tasksTable"
              :data="tareasInventario"
              v-if="tareasInventario.length > 0"
              :showHeader="false"
              style="width: 100%"
            >
              <el-table-column type="index" align="center" width="50" />
              <el-table-column prop="nombre" :label="$t('Tarea')" />
              <el-table-column
                prop="ready"
                :label="$t('Estado')"
                align="center"
                header-align="center"
                width="350"
              >
                <template slot-scope="scope">
                  <el-tag
                    class="tag"
                    type="success"
                    v-if="scope.row.riesgos"
                  >{{scope.row.riesgos.length}} {{$t('riesgos')}}</el-tag>
                  <el-tag v-else type="warning">{{$t('0 riesgos')}}</el-tag>

                  <el-tag
                    type="primary"
                    v-if="tasksThatNeedProcedure.includes(scope.row.id || scope.row._id)"
                  >{{$t('Aplica Procedimento')}}</el-tag>

                  <el-popover
                    v-if="mel && (hasStandardProcedures(scope.row) || hasCustomProcedures(scope.row))"
                    class="help-box"
                    placement="top"
                    :title="$t('Procedimiento')"
                    width="200"
                    trigger="hover"
                    :content="$t('Esta tárea tiene asignada procedimiento.')"
                  >
                    <i slot="reference">
                      <img
                        style="vertical-align: middle;"
                        class="img_pdf"
                        src="@/assets/icons/text-documents_orange.svg"
                      />
                    </i>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column align="center" header-align="center" width="450">
                <template slot-scope="scope">
                  <!-- <el-button
                    type="primary"
                    size="small"
                    v-if="mel"
                    @click="selectProcedure(scope.row)"
                  >{{$t('Seleccionar Procedimiento')}}</el-button>-->

                  <el-button
                    type="info"
                    size="small"
                    @click="editRisks(scope.row)"
                  >{{$t('Identificar riesgos')}}</el-button>
                  <el-button
                    type="danger"
                    size="small"
                    @click="deleteTask(scope.row)"
                    icon="el-icon-delete"
                  />
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-tab-pane>
      <!-- Contrato -->
      <el-tab-pane class="paddingBody" :label="$t('Contrato')">
        <MostrarContrato
          :contract="contract"
          :fatherArea="fatherArea"
          :area="area"
          :workflows="workflows"
          :peopleContract="usersFaena"
        />
      </el-tab-pane>
    </el-tabs>

    <el-dialog
      width="90%"
      top="0"
      class="iframeDialog"
      :close-on-click-modal="false"
      :show-close="true"
      :lock-scroll="true"
      :before-close="() => customProcedureDialog = false"
      :visible="customProcedureDialog"
      v-on:opened="setProcedure"
    >
      <div class="iframeContainer">
        <!--         <div style="position: absolute; right: 20px; top:5px;">
          <el-button type="primary" @click="customProcedureDialog = false">
              <b>{{$t('Cerrar')}}</b>
            </el-button>
        </div>-->
        <iframe
          id="CifrR2"
          :src="iframe.src"
          @load="setProcedure"
        >hay problemas para mostrar el contenidoD:!!</iframe>
      </div>
    </el-dialog>

    <el-dialog
      :visible="standarProcedureDialog"
      :before-close="() => standarProcedureDialog = false"
    >
      <template v-if="isVendor || cType === 'Contratista'">
        <h3>{{$t('Procedimentos')}}</h3>
        <vendorProcedures
          :selectedProcedures="selectedStandarProcedures"
          :taskId.sync="selectedTaskId"
          :contractId.sync="contractId"
          :close="standarProcedureDialog"
        />
      </template>

      <template v-else>
        <div v-if="mel">
          <h3>{{$t('Procedimentos estandarizados')}}</h3>
          <standarProcedures
            :selectedStandarProcedures="selectedStandarProcedures"
            :taskId.sync="selectedTaskId"
            :contract.sync="contract"
            :close="standarProcedureDialog"
          />
          <br />
          <div>(*)Si no encuentra un procedimiento en la lista que cumpla con el criterio de la tarea puede crear uno.</div>
        </div>

        <div>
          <el-button
            type="primary"
            @click="(standarProcedureDialog = false) || (customProcedureDialog = true)"
            :disabled="![undefined, null, 0].includes(selectedCustomProcedure.status)"
          >
            <b>{{$t('Nuevo Procedimiento')}}.</b>
          </el-button>
          <span
            v-if="![null, 0].includes(selectedCustomProcedure.status) && selectedCustomProcedure.pdf_document"
          >
            <span style="margin-left:20px">Ver nuevo procedimiento</span>
            <a :href="selectedCustomProcedure.pdf_document" target="_blank">
              <img class="img_pdf2" src="@/assets/icons/text-documents_orange.svg" />
            </a>
          </span>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import inventoryRequirements from "@/mixins/inventoryRequirements";
import MostrarContrato from "@/components/MostrarContrato.vue";
import standarProcedures from "@/procedures/standarProcedures.vue";
import vendorProcedures from "@/procedures/vendorProcedures.vue";
import { getMFL, iframeMessages } from "@/utils/generalFunctions";
import { ENDPOINT_PROCEDURE } from "@/config.js";
import { getProcedures, getInventoryDatas } from "@/procedures/requests.js";
const isSettedAndHas = (obj, key) => obj[key] && obj[key].length;

export default {
  mixins: [inventoryRequirements],
  components: {
    MostrarContrato,
    standarProcedures,
    vendorProcedures
  },
  data() {
    return {
      selectedCustomProcedure: {},
      selectedStandarProcedures: [],
      inventoryCustomProcedures: [],
      selectedTaskProcedure: {},
      selectedTaskId: null,
      window,
      iframe: {
        data: {},
        src: ENDPOINT_PROCEDURE + "inventoryProcedure"
      },
      isLoading: false,
      task: "",
      taskEditId: null,
      renameTask: "",
      saveLoading: false,
      customProcedureDialog: false,
      standarProcedureDialog: false
    };
  },
  computed: {
    ...mapGetters({
      role: "role",
      inventario: "inventario"
    }),
    cType() {
      return this.contract && this.contract.tipo_contrato;
    },
    isVendor() {
      if (this.role.admin) return false;
      if (this.role.empresa_id) return true;
      return false;
    },
    procedureRule() {
      return this.mel ? { mfl: 4, rrr: 10 } : { mfl: 3, rrr: 90 };
    },
    tasksThatNeedProcedure() {
      const ttnp = [];
      this.tareasInventario.forEach(t => {
        if (this.needProcedure(t)) ttnp.push(t.id || t._id);
      });
      return ttnp;
    },
    contractId() {
      return this.contract && (this.contract._id || this.contract.id);
    },

    mel() {
      return this.role.faena_id === "5a6f78337b772dcfe68241d5";
    },
    tareasInventario() {
      if (!this.inventario.tareas || this.inventario.tareas == null) {
        if (localStorage.getItem("inventory")) {
          this.setInventario(JSON.parse(localStorage.getItem("inventory")));
        } else {
          return [];
        }
      }
      return this.inventario.tareas;
    },
    iframe1ContentWindow() {
      return (
        document.getElementById("CifrR2") &&
        document.getElementById("CifrR2").contentWindow
      );
    }
  },
  created() {
    this.setTitle(this.$t("Inventario de riesgos"));
    iframeMessages(msj => {
      if (msj.data.procedure && msj.data.procedure.id) {
        const procedure = this.inventoryCustomProcedures.find(
          p => p.id === msj.data.procedure.id
        );
        Object.assign(procedure, msj.data.procedure);
      }
      if (msj.data.close === true) {
        this.customProcedureDialog = false;
      }
      if (msj.data.newProcedure) {
        console.log(".......", msj.data.newProcedure);
        // no se pq pero manda el mensaje 2 veces
        const res = this.inventoryCustomProcedures.find(
          f => f.id === msj.data.newProcedure.id
        );
        if (!res) this.inventoryCustomProcedures.push(msj.data.newProcedure);
      }
    });
  },
  watch: {
    inventario: {
      handler() {
        this.$store.dispatch(
          "setStatus",
          this.inventario.wasApproved === true &&
            [0, 1, "0", "1"].includes(parseInt(this.inventario.status))
            ? `${this.inventario.status}wasApproved`
            : this.inventario.status
        );
      }
    },
    contract: {
      handler() {
        if (this.contract && this.contract.nombre) {
          this.setSubTitle(`${this.$t("Contrato")}: ${this.contract.nombre}`);
          getProcedures({
            is_deleted: false,
            last_version: true,
            job_id: this.role.faena_id,
            contract_id: this.contract._id || this.contract.id
          })
            .then(r => (this.inventoryCustomProcedures = r))
            .then(r => console.log(this.inventoryCustomProcedures, "<---"));

          getInventoryDatas({
            inventory_id: this.contract._id || this.contract.id
          })
            .then(r => (this.selectedStandarProcedures = r))
            .then(r => console.log(this.selectedStandarProcedures, "<---s"))
            .catch(e => console.error(e));
        }
      }
    }
  },
  methods: {
    ...mapActions(["setTitle", "setSubTitle", "setInventario"]),
    hasCustomProcedures(row) {
      const taskId = row.id || row._id;
      return this.inventoryCustomProcedures.find(p => p.task_id === taskId);
    },
    needProcedure(task) {
      if (!isSettedAndHas(task, "riesgos")) return; // no trae riesgos o no tiene
      return !!task.riesgos.find(r => {
        if (!isSettedAndHas(r, "impactos")) return false;
        const { mfl, factor_severidad, factor_probabilidad } = r.impactos[0];
        if (!(mfl && factor_severidad && factor_probabilidad)) return false;
        const rrr = factor_severidad * factor_probabilidad;
        return mfl >= this.procedureRule.mfl || rrr >= this.procedureRule.rrr;
      });
    },
    hasStandardProcedures(row) {
      const taskId = row.id || row._id;
      return this.selectedStandarProcedures.find(
        p => p.task_id === taskId && p.procedure
      );
    },
    setProcedure() {
      if (this.iframe1ContentWindow) {
        this.iframe1ContentWindow.postMessage(
          this.iframe.data,
          "*" /* ENDPOINT_PROCEDURE */
        );
      } // if
    },
    selectProcedure(task) {
      this.selectedTaskId = task._id || task.id;
      this.selectedTaskProcedure = task;
      this.selectedCustomProcedure = this.hasCustomProcedures(task) || {};
      let riesgos = task.riesgos;
      console.log("task selected", task);
      this.iframe.data = {
        risks: riesgos,
        from: "inventory",
        areaId: this.contract.area_id,
        contractName: this.contract.nombre,
        contractId: this.contract._id,
        taskName: task.nombre,
        taskId: task._id || task.id,
        token: this.$store.getters.token,
        faenaId: this.$store.getters.role.faena_id,
        userId: this.$store.getters.user._id
      };
      if (this.isVendor || this.cType === "Constratista") {
        this.standarProcedureDialog = true;
      } else {
        this.mel
          ? (this.standarProcedureDialog = true)
          : (this.customProcedureDialog = true);
      } // if
    },
    canSendToApproval() {
      if (
        this.tareasInventario.length > 0 &&
        this.role &&
        (this.role.admin ||
          ["contractor_coordinator", "coordinator"].includes(this.role.role)) &&
        (!this.inventario.status ||
          [0, 3].includes(parseInt(this.inventario.status))) &&
        this.inventario.tareas &&
        this.inventario.tareas.length > 0
      ) {
        return true;
      }
      return false;
    },
    handleClose() {
      this.task = "";
    },
    saveInventory() {
      this.saveLoading = true;
      this.$store.dispatch("createOrUpdateDraft").then(response => {
        this.saveLoading = false;
        if (response.success) {
          this.$notify({
            duration: 3000,
            title: "Atención",
            message: "Cambios guardados exitosamente",
            type: "success"
          });
        } else {
          this.$alert(response.message, this.$t("Error"), {
            type: "error"
          });
        }
      });
    },
    closeDialogTask() {
      this.renameTask = "";
      this.taskEditId = null;
    },
    editFormTask(task) {
      this.renameTask = task.nombre;
      this.taskEditId = task.id || task._id;
    },
    handleAddTask() {
      this.$store.dispatch("addTask", this.task).then(res => {
        this.editRisks(res);
      });
      this.$notify.info({
        duration: 3000,
        title: "Atención",
        message: `${this.$t("Tarea")} "${this.task}" ${this.$t(
          "agregada exitosamente"
        )}`
      });
      this.saveInventory();
    },
    editRisks(task) {
      this.$store.dispatch("selectTask", task).then(() => {
        this.$router.push({ name: "firstStep" });
      });
    },
    deleteTask(task) {
      this.$confirm(
        this.$t(
          "Esto borrará la tareas y todos sus riesgos. ¿Está seguro que desea continuar?"
        ),
        this.$t("Atención"),
        {
          type: "warning"
        }
      ).then(() => {
        this.$store.dispatch("deleteTask", task).then(() => {
          this.$store.dispatch("createOrUpdateDraft").then(response => {
            if (response.success) {
              this.$notify.info({
                duration: 3000,
                title: "Atención",
                message: `${this.$t("Tarea")} "${task.nombre}" ${this.$t(
                  "eliminada exitosamente"
                )}`
              });
              this.saveInventory();
              this.$router.push({ name: `/inventario/${contract._id}/editar` });
            } else {
              this.$alert(response.message, this.$t("Atención"), {
                type: "error"
              });
            }
          });
        });
      });
    },
    async sendToReview() {
      // Aviso no es posible modificar
      const send = await this.$confirm(
        this.$t(
          "Una vez que se envíe este inventario a revisión no será posible realizar modificaciones. ¿Seguro que desea continuar?"
        ),
        this.$t("Atención"),
        {
          confirmButtonText: "Enviar a Revisión",
          cancelButtonText: "Cancelar"
        }
      )
        .then(() => true)
        .catch(() => {
          this.isLoading = false;
        });

      if (send) {
        // Revisar que el inventario esté completo
        let isReady = true;
        let onlyStandardized = true;
        let inventoryApproved = true;
        let proceduresOk = true;
        this.inventario.tareas.forEach(tarea => {
          const tId = tarea.id || tarea._id;
          if (!tarea.riesgos || tarea.riesgos.length === 0) {
            isReady = false;
            return;
          }

          // Validar procedimiento
          if (this.mel && this.tasksThatNeedProcedure.includes(tId)) {
            const ssp = this.selectedStandarProcedures.find(
              f => f.task_id === tId
            );
            const icp = this.inventoryCustomProcedures.find(
              f => f.task_id === tId
            );
            if (!(ssp || icp)) {
              proceduresOk = false;
              return;
            }
          }

          tarea.riesgos.forEach(riesgo => {
            if (riesgo.custom === true && riesgo.status !== 1) {
              inventoryApproved = false;
            }
            // status 2 esta aprobado
            if (riesgo.custom && !["2", 2].includes(riesgo.status)) {
              onlyStandardized = false;
              if (!this.isRiskReady(riesgo)) {
                isReady = false;
              }
            }
          });
        });

        // Si el inventario no está completo alertar
        if (!isReady) {
          this.isLoading = false;
          this.$alert(
            this.$t(
              "Debes completar todos los riesgos antes de enviar a revisión"
            ),
            this.$t("Atención"),
            {
              type: "error"
            }
          );
          return;
        }
        if (!proceduresOk) {
          this.isLoading = false;
          this.$alert(
            this.$t("Hay tareas que requieren un procedimiento"),
            this.$t("Atención"),
            {
              type: "error"
            }
          );
          return;
        }

        // Definir estado del inventario
        // 0: Borrador, 1: En Revisión, 2: Aprobado, 3: Importado, 4: Validación Medioambiente
        let status = 1;
        if (onlyStandardized) {
          status = 2;
        } else if (inventoryApproved) {
          status = 2;
        }

        // Set Inventario
        const inventario = Object.assign({}, this.inventario, {
          status,
          created_at: this.$store.getters.created_at || new Date()
        });

        // Registrar cambios en BD
        this.$store.dispatch("setInventario", inventario).then(() => {
          this.$store.dispatch("saveInventario").then(async response => {
            // actualizar el contrato en el lado cliente
            const { userContracts } = this.$store.getters;
            const contractToUpdate = userContracts.find(
              c => c._id === this.contract._id
            );
            if (contractToUpdate) {
              const invToUp = { ...contractToUpdate.inventario };
              invToUp.status = status;
              this.$store.dispatch("contractAssign", {
                obj: contractToUpdate,
                val: { inventario: invToUp }
              });
            } // if

            if (status === 1) {
              if (inventario.tareas) {
                inventario.tareas.forEach(t => {
                  if (t.riesgos) {
                    t.riesgos.forEach(r => {
                      this.saveVerificarEstadoFirstEvaluation(r);
                    });
                  }
                });
              }
            }

            this.isLoading = false;
            if (response.status) {
              if (onlyStandardized) {
                this.$alert(
                  this.$t("Inventario enviado y aprobado exitosamente"),
                  this.$t("Atención"),
                  {
                    type: "success"
                  }
                );
              } else {
                this.$alert(
                  this.$t("Inventario enviado a revisión exitosamente"),
                  this.$t("Atención"),
                  {
                    type: "success"
                  }
                );
              }

              // Redireccón a seleccón de inventarios
              this.$router.push({ name: "inventorySelectPage" });
            } else {
              this.$alert(response.message, "Atención", {
                type: "error"
              });
            }
          });
        });
      }
    },
    saveVerificarEstadoFirstEvaluation(risk) {
      if (risk.custom === true && risk.status === 0 && risk.status_step === 0) {
        const statusHistoryVal = {};
        statusHistoryVal.nombre = this.$store.getters.user.nombre;
        statusHistoryVal.nombre += ` ${this.$store.getters.user.apellido}`;
        statusHistoryVal.fecha = this.$moment().format("LLLL");

        // Cambia status segun mfl y estado actual del paso
        let { status } = risk;
        let statusStep = risk.status_step;
        const { mfl } = this.getMayorImpacto(risk);

        const workflow = this.workflows[risk.tipo.toLowerCase()];
        // mfl = riesgo de mayor nivel
        if (statusStep === 0) {
          const steps = workflow.risks[mfl - 1];
          const lastStep = steps.length;
          const actualStep = steps[statusStep];
          const { userContracts } = this.$store.getters;
          var roles_email = [];
          actualStep.peopleProfile.forEach(role => {
            if (role === "super") {
              if (this.contract.area.super_id !== "") {
                roles_email.push({
                  id_user: this.contract.area.super_id,
                  rol: "super"
                });
              }
            } else if (role === "manager") {
              if (this.contract.area.manager_id !== "") {
                roles_email.push({
                  id_user: this.contract.area.manager_id,
                  rol: "manager"
                });
              }
            } else {
              this.contract.revisores[role].forEach(r => {
                if (r !== "") {
                  roles_email.push({
                    id_user: r,
                    rol: role
                  });
                }
              });
            }
          });
          var unique_users_email = Array.from(
            new Set(roles_email.map(JSON.stringify))
          ).map(JSON.parse);
          this.$store
            .dispatch("sendEmailUser", {
              contrato: this.contract,
              usuarios: unique_users_email,
              risk: risk,
              mfl: mfl
            })
            .then(async response => {});
        }
      }
    },
    getMayorImpacto(risk) {
      let mfl = 0;
      let rrr;
      let mayorImpacto;

      if (risk.impactos) {
        risk.impactos.forEach(impacto => {
          if (impacto.mfl > mfl) {
            ({ mfl } = impacto);
            rrr =
              (impacto.factor_severidad *
                10 *
                (impacto.factor_probabilidad * 10)) /
              (10 * 10);
            mayorImpacto = impacto;
          }
        });
      }

      return {
        impacto: mayorImpacto,
        mfl,
        rrr
      };
    },
    isRiskReady(risk) {
      let isReady = true;
      if (!risk.causas || risk.causas.length === 0) {
        return false;
      }
      if (!risk.impactos || risk.impactos.length === 0) {
        return false;
      }
      risk.causas.forEach(causa => {
        if (
          !causa.controles_preventivos ||
          causa.controles_preventivos.length === 0
        ) {
          isReady = false;
        }
      });
      if (!isReady) {
        return false;
      }
      // Si es MFL < 3, no es necesario agregar controles mitigadores
      const mfl = getMFL(risk);
      if (mfl > 2) {
        risk.impactos.forEach(impacto => {
          if (
            !impacto.controles_mitigadores ||
            impacto.controles_mitigadores.length === 0
          ) {
            isReady = false;
          }
        });
        if (!isReady) {
          return false;
        }
      }
      return true;
    }
  } // methods
};
</script>

<style scoped>
.tasksTable {
  margin-top: 40px;
  max-height: 70vh;
  overflow: auto;
}
.widthinputTask {
  width: 95%;
  margin-right: 5px;
}
.tag {
  margin-right: 10px;
}
.content {
  min-height: 50vh;
}
.img_pdf {
  margin-left: 10px;
  height: 30px;
  margin-bottom: 5px;
}
.img_pdf2 {
  height: 30px;
  vertical-align: middle;
  margin-left: 10px;
}
</style>
